const TEST_MATERIAL_PRESET = {
    qinggongClassifyId: 58,
    flowerPageRange: {
        start: 1,
        end: 38,
    },
    qinggongPageIndex: 2,
    containerPageIndex: 2,
    containerPageSize: 16,
};

function getTestPresetPageRange(tab) {
    if (tab === "flowers") {
        return TEST_MATERIAL_PRESET.flowerPageRange;
    }
    return {
        start: 2,
        end: 2,
    };
}

function getTestPresetParams(params, tab) {
    const nextParams = {
        ...params,
        colorClassifyId: null,
        floweringStage: "",
        name: "",
        queryLikeMaterial: false,
    };

    if (tab === "container") {
        return {
            ...nextParams,
            classifyId1: 2,
            classifyId2: null,
            classifyId3: null,
            pageIndex: TEST_MATERIAL_PRESET.containerPageIndex,
            pageSize: TEST_MATERIAL_PRESET.containerPageSize,
        };
    }

    if (tab === "qinggong") {
        return {
            ...nextParams,
            classifyId1: 1,
            classifyId2: null,
            classifyId3: TEST_MATERIAL_PRESET.qinggongClassifyId,
            pageIndex: TEST_MATERIAL_PRESET.qinggongPageIndex,
            pageSize: 12,
        };
    }

    return {
        ...nextParams,
        classifyId1: 1,
        classifyId2: null,
        classifyId3: null,
        pageIndex: TEST_MATERIAL_PRESET.flowerPageRange.start,
        pageSize: 12,
    };
}

module.exports = {
    TEST_MATERIAL_PRESET,
    getTestPresetPageRange,
    getTestPresetParams,
};
